import { Action, ActionCondition } from "../gameData";
import { evaluateExpression } from "./evaluateExpression";
import { switchScene } from "./switchScene";

export function runAction(action: Action) {
    switch (action.type) {
        case "switchScene": {
            switchScene(action.sceneId);
            break;
        }
        case "if": {
            if (isExpressionTrue(action.if)) {
                runAction(action.then);
            } else if (action.else) {
                runAction(action.else);
            }
            break;
        }
        case "echo": {
            console.log(`[action/echo] ${action.msg}`);
            break;
        }
        default: {
            // @ts-expect-error
            throw new Error(`Unimplemented action type: "${action.type}"`);
        }
    }
}

function isExpressionTrue(cond: ActionCondition): boolean {
    return !!evaluateExpression(cond);
}
